import React from "react";
import "../../../shared/styles/dragdrop.scss";
import { Box } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import useDragDrop from "./useDragDrop";

interface DragDropProps {
  onFilesSelected: (files: File[]) => void;
  width: string;
  height: string;
}

const DragDrop = ({ onFilesSelected, width }: DragDropProps) => {
  const {
    handleRemoveFile,
    intl,
    overFileField,
    invalidFormat,
    invalidSize,
    handleFileChange,
    handleDrop,
    setOverFileField,
    files,
    filesNumber,
  } = useDragDrop({ onFilesSelected });

  return (
    <Box
      className="drag-drop"
      width={width}
      paddingX={"1rem"}
      paddingTop={"1rem"}
      paddingBottom={"1rem"}
    >
      <h6>{intl.formatMessage({ id: "SupportFilesTitle" })}</h6>
      <p>{intl.formatMessage({ id: "SupportFilesMessage" })}</p>

      <Box
        width={"100%"}
        height={"120px"}
        marginTop={"1rem"}
        paddingX={{ xs: "24px" }}
        className="document-uploader upload-box"
        onDragOver={(event) => {
          event.preventDefault();
        }}
        onDragEnter={() => {
          setOverFileField(true);
        }}
      >
        {overFileField ? (
          <div
            className="bg-gray text-white"
            onDragEnter={() => setOverFileField(true)}
            onDragLeave={() => setOverFileField(false)}
            onDrop={(e) => handleDrop(e)}
            style={{ height: "100%", width: "100%", zIndex: 99999 }}
          >
            {intl.formatMessage({ id: "DropFilesHere" })}
          </div>
        ) : (
          <>
            <label htmlFor="browse">
              <div className="upload-info">
                <AttachFileIcon />
                <p style={{ fontSize: "14px" }}>
                  {intl.formatMessage({ id: "DragYourFilesHere" })}
                </p>
              </div>
              <input
                type="file"
                hidden
                id="browse"
                onChange={(e) => handleFileChange(e)}
                accept="application/pdf,application/zip,image/jpeg,image/png,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                multiple
              />
            </label>
          </>
        )}
      </Box>
      {invalidFormat.length > 0 && (
        <Box
          marginTop={"1rem"}
          paddingRight={"0.3rem"}
          className="overflow-wrap-anywhere"
        >
          <span className="field-error ml-0 d-block">
            {intl.formatMessage({ id: "InvalidFilesFormat" })}:
          </span>
          <span className="field-error ml-0">{invalidFormat} </span>
        </Box>
      )}

      {invalidSize.length > 0 && (
        <Box
          marginTop={"1rem"}
          paddingRight={"0.3rem"}
          className="overflow-wrap-anywhere"
        >
          <span className="field-error ml-0 d-block">
            {intl.formatMessage({ id: "InvalidSizeFormat" })}:
          </span>
          <span className="field-error ml-0">{invalidSize} </span>
        </Box>
      )}
      {filesNumber > 20 && (
        <Box marginTop={"1rem"}>
          <span className="field-error ml-0">
            {intl.formatMessage({ id: "Up20Files" })}
          </span>
        </Box>
      )}
      <Box marginTop={"1rem"}>
        {files.length > 0 && (
          <Box style={{ maxHeight: "120px", overflowY: "auto", width: "100%" }}>
            {files.map((file, index) => (
              <div className="file-item" key={index}>
                <div className="file-info">
                  <p>{file.name}</p>
                </div>
                <div className="file-actions">
                  <CloseIcon onClick={() => handleRemoveFile(index)} />
                </div>
              </div>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DragDrop;
